const postsSliderInit = (block) => {
    const sliders = block ? [block[0].querySelector(".bn-blog-posts .swiper")] : Array.from(document.querySelectorAll('.bn-blog-posts .swiper'));
    
    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const ballTrack = slider.parentNode.querySelector('.swiper-ball-track');
                const ball = ballTrack ? ballTrack.querySelector('.swiper-ball') : null;

                const updateBallPosition = (swiper) => {
                    if (!ball || !ballTrack) return;
                    
                    const totalSlides = swiper.slides.length;
                    const slidesPerView = swiper.params.slidesPerView;
                    const lastSlideIndex = totalSlides - slidesPerView;
                    let currentPage = swiper.realIndex;

                    let percent = (currentPage / lastSlideIndex) * 100;

                    ball.style.left = `${percent}%`;
                }

                const sliderConfig = {
                    observer: true,
                    observeSlideChildren: true,
                    rewind: true,
                    autoplay: {
                        delay: 5000,
                    },
                    slidesPerView: 1,
                    allowTouchMove: slider.dataset.allowtouchmove === "0",
                    navigation: {
                        nextEl: slider.parentNode.querySelector(".swiper-button-next"),
                        prevEl: slider.parentNode.querySelector(".swiper-button-prev"),
                    },
                    spaceBetween: 10,
                    breakpoints: {
                        576: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 35,
                        },
                        1600: {
                            slidesPerView: 4,
                        }
                    },
                    on: {
                        init: function (swiper) { updateBallPosition(swiper); },
                        slideChange: function (swiper) { updateBallPosition(swiper); },
                        resize: function (swiper) { updateBallPosition(swiper); }
                    }
                }

                let currentSlider = new Swiper(slider, sliderConfig);
                currentSlider.on( 'observerUpdate', () => {
                    currentSlider.destroy(currentSlider, true);
                    currentSlider = new Swiper(slider, sliderConfig);
                });
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        postsSliderInit();
    else if (window.acf)
        window.acf.addAction('render_block_preview/type=bn/blog-posts', postsSliderInit);
});